
(function () {
  "use strict";

  const CONFIG = {
    offers: [
      {
        id: "offer_1",
        mainVariantId: 45693386326214,
        giftVariantId: 47090213355718
      },
      {
        id: "offer_2",
        mainVariantId: 45693349298374,
        giftVariantId: 45707891081414
      },
      {
        id: "offer_3",
        mainVariantId: 45826529722566,
        giftVariantId: 47090213355718
      }
    ]
  };

  const originalFetch = window.fetch.bind(window);

  let syncing = false;
  let syncAgain = false;
  let cartChanged = false;

  // Detect Shopify cart modification requests.
  function isCartMutation(input) {
    try {
      const url =
        typeof input === "string"
          ? input
          : input && input.url
            ? input.url
            : "";

      const path = new URL(url, window.location.origin).pathname;

      return /\/cart\/(add|change|update|clear)(\.js)?$/.test(path);
    } catch (error) {
      return false;
    }
  }

  // Retrieve the latest cart.
  async function getCart() {
    const response = await originalFetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store"
    });

    if (!response.ok) {
      throw new Error("Unable to retrieve cart");
    }

    return response.json();
  }

  // Add the gift for an offer.
  async function addGift(offer) {
    const response = await originalFetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: offer.giftVariantId,
            quantity: 1,
            properties: {
              "_wellncare_free_gift": "yes",
              "_wellncare_offer": offer.id
            }
          }
        ]
      })
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error("Gift addition failed: " + error);
    }
  }

  // Remove a gift.
  async function removeGift(item) {
    const response = await originalFetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: item.key,
        quantity: 0
      })
    });

    if (!response.ok) {
      throw new Error("Gift removal failed");
    }
  }

  // Refresh cart drawer and icon on other pages.
  async function refreshCartDrawer() {
    try {
      const sectionIds = [
        "cart-drawer",
        "cart-icon-bubble"
      ];

      const response = await originalFetch(
        "/?sections=" + sectionIds.join(","),
        {
          credentials: "same-origin",
          cache: "no-store"
        }
      );

      if (!response.ok) return;

      const sections = await response.json();
      const parser = new DOMParser();

      // Update cart drawer.
      if (sections["cart-drawer"]) {
        const parsed = parser.parseFromString(
          sections["cart-drawer"],
          "text/html"
        );

        const currentDrawer = document.querySelector("#CartDrawer");
        const newDrawer = parsed.querySelector("#CartDrawer");

        if (currentDrawer && newDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        } else {
          const currentSection = document.getElementById(
            "shopify-section-cart-drawer"
          );

          const newSection = parsed.getElementById(
            "shopify-section-cart-drawer"
          );

          if (currentSection && newSection) {
            currentSection.innerHTML = newSection.innerHTML;
          }
        }
      }

      // Update cart icon.
      if (sections["cart-icon-bubble"]) {
        const parsed = parser.parseFromString(
          sections["cart-icon-bubble"],
          "text/html"
        );

        const currentBubble = document.querySelector(
          "#cart-icon-bubble"
        );

        const newBubble = parsed.querySelector(
          "#cart-icon-bubble"
        );

        if (currentBubble && newBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }
      }

    } catch (error) {
      console.error("Cart drawer refresh error:", error);
    }
  }

  // Final display refresh after gift synchronization.
  async function updateVisibleCart() {
    if (!cartChanged) return;

    // On the full cart page, reload the page to render
    // the latest Shopify cart and all cart line items.
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }

    // On other pages, update the cart drawer.
    await refreshCartDrawer();
  }

  // Synchronize all three offers.
  async function syncCartGifts() {
    if (syncing) {
      syncAgain = true;
      return;
    }

    syncing = true;
    cartChanged = false;

    try {
      do {
        syncAgain = false;

        let cart = await getCart();

        for (const offer of CONFIG.offers) {

          // Check qualifying product.
          const qualifyingProductExists = cart.items.some(
            function (item) {
              return Number(item.variant_id) === offer.mainVariantId;
            }
          );

          // Find this offer's gift only.
          const giftItems = cart.items.filter(
            function (item) {
              return (
                Number(item.variant_id) === offer.giftVariantId &&
                item.properties &&
                item.properties["_wellncare_free_gift"] === "yes" &&
                item.properties["_wellncare_offer"] === offer.id
              );
            }
          );

          if (qualifyingProductExists) {

            // Add gift if missing.
            if (giftItems.length === 0) {
              await addGift(offer);

              cartChanged = true;
              cart = await getCart();
            }

            // Keep only one gift per offer.
            if (giftItems.length > 1) {
              for (const extraGift of giftItems.slice(1)) {
                await removeGift(extraGift);

                cartChanged = true;
                cart = await getCart();
              }
            }

          } else {

            // Remove the gift if qualifying product is removed.
            for (const gift of giftItems) {
              await removeGift(gift);

              cartChanged = true;
              cart = await getCart();
            }
          }
        }

      } while (syncAgain);

    } catch (error) {
      console.error("Wellncare free gift error:", error);

    } finally {
      syncing = false;
    }

    // Refresh only after all offers have been synchronized.
    await updateVisibleCart();
  }

  // Intercept Shopify AJAX cart requests, including Quick Buy.
  window.fetch = async function (...args) {
    const response = await originalFetch(...args);

    if (isCartMutation(args[0])) {
      setTimeout(function () {
        syncCartGifts();
      }, 200);
    }

    return response;
  };

  // Synchronize existing cart on page load.
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      syncCartGifts,
      { once: true }
    );
  } else {
    syncCartGifts();
  }

  // Recheck cart when returning to the page.
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      syncCartGifts();
    }
  });

})();
